export const has = Object.prototype.hasOwnProperty;
